import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_URL } from "../components/config"; // Adjust the import based on your project structure
const TicketPage = () => {
  const { id } = useParams();
  const [ticket, setTicket] = useState(null);
  const [progress, setProgress] = useState([]);

  useEffect(() => {
    const fetchTicket = async () => {
      const response = await fetch(`${API_URL}/tickets/id/${id}`);
      const data = await response.json();
      setTicket(data);
    };

    const fetchProgress = async () => {
      const response = await fetch(`${API_URL}/tickectprogress/ticket/${id}`);
      const data = await response.json();
      setProgress(data);
    };

    fetchTicket();
    fetchProgress();
  }, []);

  if (!ticket) {
    return <div>Loading...</div>;
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2>Ticket Details</h2>
        <p>
          <strong>Assigned To:</strong> {ticket.person_assigned}
        </p>
        <p>
          <strong>Status:</strong> {ticket.conversation_stage}
        </p>
        <p>
          <strong>Priority Level:</strong> {ticket.priority_level}
        </p>
        <p>
          <strong>Estimated Duration:</strong> {ticket.estimation_duration}
        </p>
        <p>
          <strong>Expiry Date:</strong> {ticket.expiry_date_time}
        </p>
      </div>
      <div style={styles.notes}>
        <h3>Progress Notes</h3>
        {progress.map((item) => (
          <div key={item.ticket_progress_id} style={styles.note}>
            <p>
              <strong>Status:</strong> {item.status}
            </p>
            <p>
              <strong>Action Notes:</strong> {item.action_notes}
            </p>
            <p>
              <strong>Received At:</strong>{" "}
              {new Date(item.received_at_date_time).toLocaleString()}
            </p>
            <p>
              <strong>Left At:</strong>{" "}
              {new Date(item.left_at_date_time).toLocaleString()}
            </p>
            <img
              src={item.pinned_images_url}
              alt="Progress"
              style={styles.image}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "20px",
    fontFamily: "Arial, sans-serif",
  },
  card: {
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "15px",
    marginBottom: "20px",
    backgroundColor: "#f9f9f9",
  },
  notes: {
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "15px",
    backgroundColor: "#f9f9f9",
  },
  note: {
    borderBottom: "1px solid #eee",
    padding: "10px 0",
  },
  image: {
    maxWidth: "100%",
    height: "auto",
    marginTop: "10px",
  },
};

export default TicketPage;
